

/* tslint:disable */



export enum GuidelineActionSignificance {
    Required = 0,
    Optional = 1,

}


